import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=07820404&scoped=true&"
import script from "./videoList.vue?vue&type=script&lang=ts&"
export * from "./videoList.vue?vue&type=script&lang=ts&"
import style0 from "./videoList.vue?vue&type=style&index=0&id=07820404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07820404",
  null
  
)

export default component.exports